/* eslint-disable no-shadow */
export enum RecoveryStatus {
	pending = 'pending',
	inProgress = 'inProgress',
	inSite = 'inSite',
	recovered = 'recovered',
	failed = 'failed',
	canceled = 'canceled',
}

export const activeRecoveryStatuses = [
	RecoveryStatus.pending,
	RecoveryStatus.inProgress,
	RecoveryStatus.inSite,
];

export const RecoveryStatusValues: {
	[key in RecoveryStatus]: { title: string; color: string };
} = {
	[RecoveryStatus.pending]: {
		title: 'Por recuperar',
		color: 'yellow_100',
	},
	[RecoveryStatus.inProgress]: {
		title: 'En proceso',
		color: 'primary_300',
	},
	[RecoveryStatus.inSite]: {
		title: 'En sitio',
		color: 'primary_200',
	},
	[RecoveryStatus.failed]: {
		title: 'No recuperada',
		color: 'red_300',
	},
	[RecoveryStatus.recovered]: {
		title: 'Recuperada',
		color: 'green_300',
	},
	[RecoveryStatus.canceled]: {
		title: 'Cancelada',
		color: 'neutral_1000',
	},
};

export enum RecoveryFinalConditions {
	preventiveVisit = 'preventiveVisit',
	clientFound = 'clientFound',
	refuseRecovery = 'refuseRecovery',
	addressFound = 'addressFound',
	addressNotExist = 'addressNotExist',
	addressNoResponse = 'addressNoResponse',
	vehicleFound = 'vehicleFound',
	vehicleStolen = 'vehicleStolen',
	recovered = 'recovered',
	devolution = 'devolution',
	recoveryExpired = 'recoveryExpired',
	otherRecovery = 'otherRecovery',
	loanWriteOff = 'loanWriteOff',
	collectionPaid = 'collectionPaid',
	routeCancelation = 'routeCancelation',
	paidOnSite = 'paidOnSite',
	agreementOnSite = 'agreementOnSite',
}

export const RecoveryFailedConditions = [
	RecoveryFinalConditions.preventiveVisit,
	RecoveryFinalConditions.clientFound,
	RecoveryFinalConditions.refuseRecovery,
	RecoveryFinalConditions.addressFound,
	RecoveryFinalConditions.addressNotExist,
	RecoveryFinalConditions.addressNoResponse,
	RecoveryFinalConditions.vehicleFound,
	RecoveryFinalConditions.vehicleStolen,
];

export const RecoveryRecoveredConditions = [
	RecoveryFinalConditions.recovered,
	RecoveryFinalConditions.devolution,
];

export const RecoveryCanceledConditions = [
	RecoveryFinalConditions.recoveryExpired,
	RecoveryFinalConditions.otherRecovery,
	RecoveryFinalConditions.loanWriteOff,
	RecoveryFinalConditions.collectionPaid,
	RecoveryFinalConditions.routeCancelation,
	RecoveryFinalConditions.paidOnSite,
	RecoveryFinalConditions.agreementOnSite,
];

export const AddressRecoveryFinalConditions = [
	RecoveryFinalConditions.addressFound,
	RecoveryFinalConditions.addressNotExist,
	RecoveryFinalConditions.addressNoResponse,
];

export const RecoveryFinalConditionsValues: {
	[key in RecoveryFinalConditions]: { title: string; hidden?: boolean };
} = {
	[RecoveryFinalConditions.preventiveVisit]: {
		title: 'Visita Preventiva',
	},
	[RecoveryFinalConditions.clientFound]: {
		title: 'Cliente Localizado',
	},
	[RecoveryFinalConditions.refuseRecovery]: {
		title: 'Se Niega a Entregar',
	},
	[RecoveryFinalConditions.addressFound]: {
		title: 'Domicilio Localizada',
		hidden: true,
	},
	[RecoveryFinalConditions.addressNotExist]: {
		title: 'Domicilio No Existe',
		hidden: true,
	},
	[RecoveryFinalConditions.addressNoResponse]: {
		title: 'No Atienden en el Domicilio',
		hidden: true,
	},
	[RecoveryFinalConditions.vehicleFound]: {
		title: 'Moto Localizada',
	},
	[RecoveryFinalConditions.vehicleStolen]: {
		title: 'Moto Robado',
	},

	[RecoveryFinalConditions.recovered]: {
		title: 'Recuperada',
		hidden: true,
	},
	[RecoveryFinalConditions.devolution]: {
		title: 'Devuelta',
		hidden: true,
	},

	[RecoveryFinalConditions.paidOnSite]: {
		title: 'Cuenta al Corriente',
	},
	[RecoveryFinalConditions.agreementOnSite]: {
		title: 'Promesa de Pago',
	},
	[RecoveryFinalConditions.recoveryExpired]: {
		title: 'No visitado por tiempo',
	},
	[RecoveryFinalConditions.otherRecovery]: {
		title: 'Resulto en otra recuperación',
		hidden: true,
	},
	[RecoveryFinalConditions.loanWriteOff]: {
		title: 'Credito en WriteOff',
		hidden: true,
	},
	[RecoveryFinalConditions.collectionPaid]: {
		title: 'pago en cobranza',
		hidden: true,
	},
	[RecoveryFinalConditions.routeCancelation]: {
		title: 'Ruta cancelada',
		hidden: true,
	},
};
